import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import type { Employee } from "@/pages/human-resources/time-management/business/Employee.ts";
import { immerable } from "immer";
import type { EmployeeSchedules } from "@/pages/human-resources/time-management/business/EmployeeSchedules.ts";
import type { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";

export class EmployeeDaySchedule {
  [immerable] = true;

  public readonly employee: Employee;
  public readonly schedule: Schedule | undefined;
  public readonly mainSiteContract: Contract | undefined;
  public readonly otherSitesSchedules: Schedule[];

  constructor(es: EmployeeSchedules, date: Date) {
    this.employee = es.employee;
    this.schedule = es.getMainSchedule(date);
    this.otherSitesSchedules = es.getOtherSitesSchedules(date);
    this.mainSiteContract = es.employee.mainSiteContractAtDate(date);
  }
}
